import { IconFont } from '@/components/iconfont';
import styles from './header-action.module.scss';
import { Menu } from '@base-ui/react/menu';
import { IHeaderAction } from '../../types';
import { TooltipButton } from '@/components/tooltip';
import { ShortcutTip } from '@/components/shortcut-tip';

interface ActionProps {
  action: IHeaderAction;
  isMenuItem?: boolean;
}

export function HeaderAction({ action, isMenuItem }: ActionProps) {
  if (action.children) {
    if (isMenuItem) {
      return (
        <Menu.SubmenuRoot>
          <Menu.SubmenuTrigger className={styles.action} disabled={action.disabled}>
            <div className={styles.icon} data-more="true">
              <IconFont iconName={action.iconName} />
            </div>
            <div className={styles.title}>{action.label}</div>
          </Menu.SubmenuTrigger>
          <Menu.Portal>
            <Menu.Positioner align="start" side="bottom" sideOffset={4}>
              <Menu.Popup className={styles.children}>{action.children}</Menu.Popup>
            </Menu.Positioner>
          </Menu.Portal>
        </Menu.SubmenuRoot>
      );
    }

    return (
      <Menu.Root>
        <Menu.Trigger openOnHover delay={0} className={styles.action} disabled={action.disabled}>
          <div className={styles.icon} data-more="true">
            <IconFont iconName={action.iconName} />
          </div>
          <div className={styles.title}>{action.label}</div>
        </Menu.Trigger>
        <Menu.Portal>
          <Menu.Positioner align="start" alignOffset={0} side="bottom" sideOffset={4}>
            <Menu.Popup className={styles.children}>{action.children}</Menu.Popup>
          </Menu.Positioner>
        </Menu.Portal>
      </Menu.Root>
    );
  }

  if (isMenuItem) {
    return (
      <Menu.Item
        className={styles.action}
        data-disabled={action.disabled}
        onClick={action.disabled ? undefined : action.onClick}
        nativeButton
        render={(props) => (
          <TooltipButton
            {...props}
            tooltip={action.shortcut ? <ShortcutTip shortcut={action.shortcut} /> : undefined}
            side="bottom"
            align="center"
            sideOffset={10}
          />
        )}
      >
        <div className={styles.icon} data-more="false">
          <IconFont iconName={action.iconName} />
        </div>
        <div className={styles.title}>{action.label}</div>
      </Menu.Item>
    );
  }

  return (
    <TooltipButton
      className={styles.action}
      data-disabled={action.disabled}
      onClick={action.disabled ? undefined : action.onClick}
      tooltip={action.shortcut ? <ShortcutTip shortcut={action.shortcut} /> : undefined}
      side="bottom"
      align="center"
      sideOffset={6}
    >
      <div className={styles.icon} data-more="false">
        <IconFont iconName={action.iconName} />
      </div>
      <div className={styles.title}>{action.label}</div>
    </TooltipButton>
  );
}
